import React from 'react';

const ActionIcon = (props) => {
    return (
        <img className="ActionIcon" src={props.image} alt={props.label} onClick={props.onClick} />
    )
}

export default ActionIcon;